<script>
    import app from '../data/app.svelte.js';
    import persistent from '../data/persistent.svelte';
    import { currentSession, currentSessionId } from '../data/session.svelte.js';

    import { _ } from 'svelte-i18n';
    import { next, previous, goto, replace } from '../helpers/navigation.svelte.js';
    import { fetchApi } from '../helpers/api.svelte.js';
    import { escapeHtml } from '../helpers/escape.js';
    import Icon from '../components/Icon.svelte';
    import arrowRightIcon from '../assets/icons/arrow-right.svg?raw';

    import Section from '../components/Section.svelte';
    import Navigation from '../components/Navigation.svelte';
    import Button from '../components/Button.svelte';
    import Back from '../components/Back.svelte';
    import Code from '../components/Verify/Code.svelte';

    const current = 'validate';

    let code = $state('');
    let isValidCode = $derived(code.length === 4);

    // Determine validation method (email or sms)
    let validationMethod = $derived(app.settings.customer.validate.method || 'email');


    /* Reset the code */

    function resetCode() {
        code = '';
    }


    /* Validate the code */

    async function validateCode() {
        if (!isValidCode) {
            return;
        }

        const form = new FormData();
        form.append('session', currentSessionId);
        form.append('client', currentSession.client);
        form.append('salon', currentSession.salon);
        form.append('guid', persistent.guid);
        form.append('code', code);

        const data = await fetchApi({
            endpoint: 'OnlineAppointment.Remote.Customer/validate',
            data: form
        });

        if (data.status === 'ok') {
            if (currentSession.pendingCustomer) {
                persistent.customer = currentSession.pendingCustomer;
                currentSession.customer = currentSession.pendingCustomer;
                currentSession.pendingCustomer = null;
            }
            goto(next(current), 'right');
        } else if (data.status === 'validate') {
            resetCode();
        } else {
            replace('error/validate-failed');
        }
    }


    /* Go back to welcome */

    function goBack() {
        goto(previous(current), 'left');
    }


</script>

<svelte:head>
    <title>{$_('appointment_title')} - {$_('verification')}</title>
</svelte:head>

<Section title={$_('verification')}>
    {#snippet back()}
        <Back onclick={goBack} />
    {/snippet}

    {#if validationMethod === 'sms'}
        <p>
            {@html $_('validation_sms_sent', { values: { telephone: escapeHtml(currentSession.pendingCustomer?.telephone || '') } })}
        </p>
        <p>
            {$_('validation_sms_instructions')}
        </p>
    {:else}
        <p>
            {@html $_('validation_email_sent', { values: { email: escapeHtml(currentSession.pendingCustomer?.email || '') } })}
        </p>
        <p>
            {$_('validation_email_instructions')}
        </p>
    {/if}

    <Code bind:value={code} onSubmit={validateCode} />

    {#snippet navigation()}
        <Navigation>
            <Button color="accent" onclick={validateCode} disabled={!isValidCode}>
                {$_('next')}
                <Icon data={arrowRightIcon} />
            </Button>
        </Navigation>
    {/snippet}
</Section>
